import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [u, setU] = useState('');
  const [p, setP] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      await login(u, p);
      navigate('/admin');
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-shell">
      <div className="login-card">
        <h1>admin — espace privé</h1>
        <p style={{ marginBottom: '1.5rem', color: 'var(--ink-soft)' }}>Seule l'admin peut entrer ici.</p>
        <form onSubmit={submit}>
          {err && <div className="flash error">{err}</div>}
          <div className="form-group">
            <label>Utilisateur</label>
            <input value={u} onChange={e => setU(e.target.value)} autoFocus required />
          </div>
          <div className="form-group">
            <label>Mot de passe</label>
            <input type="password" value={p} onChange={e => setP(e.target.value)} required />
          </div>
          <button className="btn" type="submit" disabled={loading}>
            {loading ? 'connexion...' : 'se connecter →'}
          </button>
        </form>
      </div>
    </div>
  );
}
